// Services
import { AccountsService } from 'apps/accounts/static/accounts/ts/services/accounts.service';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import { CUSTOMIZE_PAGES_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import * as i0 from "@angular/core";
import * as i1 from "apps/accounts/static/accounts/ts/services/accounts.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i4 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
const _c0 = a0 => ({ active: a0 });
function ChartTypeButtonComponent_a_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 1);
    i0.ɵɵlistener("click", function ChartTypeButtonComponent_a_0_Template_a_click_0_listener() { const chartTypeOption_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateChartType(chartTypeOption_r2)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const chartTypeOption_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0, chartTypeOption_r2 === ctx_r2.userChartType));
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", i0.ɵɵinterpolate1("icon-chart-", chartTypeOption_r2));
} }
const STOCK_FUNDAMENTALS_CHART_TYPE_OPTIONS = ['line', 'bars'];
const USER_PREFERENCE_NAME = 'stock_fundamentals_chart_type';
export class ChartTypeButtonComponent {
    constructor(accountsService) {
        this.accountsService = accountsService;
        this.USER = window.USER;
        this.chartTypeOptions = STOCK_FUNDAMENTALS_CHART_TYPE_OPTIONS;
        this.userChartType = 'line';
    }
    ngOnInit() {
        this.accountsService.getUserPreferences().subscribe({
            next: (preference) => {
                this.userChartType = preference[USER_PREFERENCE_NAME];
            },
            error: () => { },
        });
    }
    updateChartType(chartType) {
        if (chartType !== this.userChartType) {
            if (this.USER.authenticated) {
                this.userChartType = chartType;
                this.accountsService.putUserPreferences({ [USER_PREFERENCE_NAME]: chartType }).subscribe(() => {
                    window.location.reload();
                });
            }
            else {
                this.featureNeededComponent.openModal(CUSTOMIZE_PAGES_FEATURE);
            }
        }
    }
}
ChartTypeButtonComponent.ɵfac = function ChartTypeButtonComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ChartTypeButtonComponent)(i0.ɵɵdirectiveInject(i1.AccountsService)); };
ChartTypeButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChartTypeButtonComponent, selectors: [["ycn-chart-type-button"]], viewQuery: function ChartTypeButtonComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededComponent = _t.first);
    } }, standalone: false, decls: 2, vars: 1, consts: [["class", "btn btn-secondary", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "btn", "btn-secondary", 3, "click", "ngClass"], ["ycnIcon", "", 3, "name"]], template: function ChartTypeButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ChartTypeButtonComponent_a_0_Template, 2, 5, "a", 0);
        i0.ɵɵelement(1, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.chartTypeOptions);
    } }, dependencies: [i2.NgClass, i2.NgForOf, i3.FeatureNeededComponent, i4.IconDirective], encapsulation: 2 });
